import { fn_bridge_order_cancel } from "../function/FnPosBridge";
import { Fn_activeAxios } from "../function/FnConfig";
import { fn_change_step } from "../function/FnBodyStep";
import { fn_deliveryCallFail } from "../function/FnBodyLayer";
import moment from "moment";
import { reload_end_order_list } from "./EndOrderConn";
import { reload_order_list_all } from "./OrderConn";
import { fn_soldOutForOrder } from "../function/FnBodyMenu";
import { fn_devliery_connect_add_reset, fn_connectDlvAppInit } from "function/FnBodyDelivery";
import { search_dlv_store_info } from "./dlvCommonConn";

//좌측 타입별 주문 카운트
export function update_detail_shop_memo(rootStore) {
  const searchStore = rootStore.searchStore;
  const viewStore = rootStore.viewStore;

  let data = JSON.stringify({
    ...searchStore.getShopCdSaleDate,
    mobileOrderNo: viewStore.getOrderDetail.mobileOrderNo,
    shopMemo: viewStore.getOrderDetail.shopMemo,
  });
  const api = Fn_activeAxios(rootStore);

  api
    .post("/gate/okgo/update_detail_shop_memo", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            reload_order_list_all(rootStore, rootStore.searchStore.getCurrOrderType);
          }
        }
      }
    })
    .catch(err => {});
}

// 상품 품절처리
export function prod_sold_out(rootStore) {
  const searchStore = rootStore.searchStore;
  const viewStore = rootStore.viewStore;

  let data = JSON.stringify({
    shopCd: searchStore.getShopCd,
    connPosNo: searchStore.getSession.connPosNo,
    items: viewStore.getOrderSoldOutProdUpdate,
  });

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/update_sold_out", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      // 레이어닫기
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          //fn_change_step(rootStore, '900');
          fn_bridge_order_cancel(rootStore);
          //설정-메뉴품절 store 맞추기.
          fn_soldOutForOrder(rootStore);
        }
      }
    })
    .catch(err => {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    });
}

// 주소 변경 처리
export function update_address(rootStore) {
  if (!rootStore.viewStore.getSelectAddrVal) {
    return;
  }

  const searchStore = rootStore.searchStore;
  const viewStore = rootStore.viewStore;

  const addr = viewStore.getSelectRoadAddrVal ? viewStore.getSelectAddrVal : viewStore.getClickedAddress;
  const addr2 = viewStore.getSelectRoadAddrVal || "";

  let data = JSON.stringify({
    ...searchStore.getShopCdSaleDate,
    mobileOrderFg: viewStore.getOrderDetail.mobileOrderFg,
    mobileOrderNo: viewStore.getOrderDetail.mobileOrderNo,
    addr: addr,
    dtl: rootStore.viewStore.getDetailSearchAddrDetail,
    addr2: addr2,
    dtl2: "" /*rootStore.viewStore.getDetailSearchAddrDetail*/,
  });

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/update_address", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      // 레이어닫기
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          if (res.data.data === 1) {
            // Detail객체 수정
            rootStore.viewStore.setChangeViewObj("dlvAddr", addr);
            rootStore.viewStore.setChangeViewObj("addr2", addr2);
            rootStore.viewStore.setChangeViewObj("dlvAddrDetail", rootStore.viewStore.getDetailSearchAddrDetail);
            rootStore.viewStore.setChangeViewObj(
              "dlvAddrFull",
              addr + " " + rootStore.viewStore.getDetailSearchAddrDetail
            );

            // Detail객체 수정내용으로 리스트 부분 수정
            rootStore.orderStore.addListByViewObj(rootStore.viewStore.getOrderDetail);
            rootStore.endOrderStore.addListByViewObj(rootStore.viewStore.getOrderDetail);

            rootStore.viewStore.setDetailSearchAddr("");
            rootStore.layerStore.setLayerAddressSearch(false);
          }
        }
      }
    })
    .catch(err => {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    });
}

// 자체 배달 처리
export function fn_self_delivery_request(rootStore) {
  const searchStore = rootStore.searchStore;
  const viewStore = rootStore.viewStore;
  const deliveryStore = rootStore.deliveryStore;
  const orderStore = rootStore.orderStore;
  const orderEndStore = rootStore.endOrderStore;

  let data = {
    shopCd: searchStore.getShopCd,
    mobileOrderFg: viewStore.getOrderDetail.mobileOrderFg,
    mobileOrderNo: viewStore.getOrderDetail.mobileOrderNo,
    saleDate: searchStore.getSaleDate,
    stepCd: orderStore.getCheckDeposit.stepCd,
    orderNo: viewStore.getOrderDetail.orderNo,
    posNo: searchStore.getSession.connPosNo,
  };

  switch (orderStore.getCheckDeposit.stepCd) {
    case "500":
      data = {
        ...data,
        selfDeliveryManCode: deliveryStore.getSelfDelivery.emp_no,
        selfDeliveryManName: deliveryStore.getSelfDelivery.emp_nm,
      };
      break;
    case "700":
      data = {
        ...data,
        payFg: orderStore.getCheckDeposit.payFg,
      };
      break;
  }
  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/selfDeliveryUpdateInfo", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.data === "SUCCESS") {
          switch (orderStore.getCheckDeposit.stepCd) {
            case "500":
              fn_change_step(rootStore, orderStore.getCheckDeposit.stepCd, "self");
              break;
            case "700":
              const moment = require("moment");
              const today = moment();
              rootStore.viewStore.setChangeViewObj("stepCd", orderStore.getCheckDeposit.stepCd);
              rootStore.viewStore.setChangeViewObj("dlvStatusFg", "04");
              rootStore.viewStore.setChangeViewObj("dlvDeliveryTime", today.format("YYYYMMDDHHmmss"));
              rootStore.viewStore.setChangeViewObj("payFg", "04");
              //rootStore.viewStore.setChangeViewObj("deliveryStatus", (orderStore.getCheckDeposit.payFg === '01') ? "CASH" : "CARD")
              rootStore.viewStore.setChangeViewObj("deliveryStatusView", "배송완료");
              if (rootStore.searchStore.getCurrStepType === "end") {
                reload_end_order_list(rootStore);
              } else {
                reload_order_list_all(rootStore);

                if (rootStore.layerStore.getLayerAlertType) {
                  rootStore.layerStore.setLayerAlertView(true);
                }
              }
              break;
            case "200":
              break;
          }
        } else {
          fn_deliveryCallFail(rootStore);
        }
      } else {
        fn_deliveryCallFail(rootStore);
      }
    })
    .catch(err => {
      fn_deliveryCallFail(rootStore);
    })
    .finally(() => {
      rootStore.layerStore.setLayerDeliveryCall(false); // 배달요청 레이어 닫기
      rootStore.deliveryStore.initDeliveryListFee(); // 배달비 초기화
      rootStore.deliveryStore.setExpDelivery(rootStore.deliveryStore.getExpDelivery); // 배달대행사 0번째 지정
    });
}

//문의하기
export function send_vo_cs(rootStore) {
  const searchStore = rootStore.searchStore;
  const viewStore = rootStore.viewStore;

  let data = JSON.stringify({
    hpTelNo: viewStore.getVocsDetail.hpTelNo,
    vocMsg: viewStore.getVocsDetail.vocMsg,
    shopCd: searchStore.getShopCd,
    voType: viewStore.getVocsTypeKeyVal.code,
  });

  const api = Fn_activeAxios(rootStore);

  api
    .post("/gate/okgo/vocs", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          const data = res.data.data;
          if (data) {
            rootStore.layerStore.setLayerCsView(false);
            rootStore.layerStore.setLayerAlertType("vocs_confirm");
            rootStore.layerStore.setLayerAlertView(true);
            rootStore.viewStore.setVocsInitDetail();
          }
        }
      }
    })
    .catch(err => {});
}

//배달대행사 목록
export function delivery_connect_list(rootStore) {
  const searchStore = rootStore.searchStore;
  const api = Fn_activeAxios(rootStore);
  api
    .get("/gate/okgo/" + searchStore.getShopCd + "/delivery-services", {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          let data = res.data.data;
          rootStore.deliveryStore.setDeliveryConnectList(data);
          return true;
        }
      }
    })
    .catch(err => {});
}

//배달 대행사 연동하기
export async function delivery_connect_request(rootStore) {
  const searchStore = rootStore.searchStore;

  let data = JSON.stringify({
    activate: true,
    agencyCode: rootStore.settingStore.getDlvRegistInfo.agencyCode,
    storeTel: rootStore.settingStore.getDlvRegistInfo.storeTel,
    shopName: rootStore.settingStore.getDlvRegistInfo.shopName,
    shopCd: searchStore.getShopCd,
    autoMappingYn: rootStore.settingStore.getDlvRegistInfo.autoMappingYn,
    deliveryCode: rootStore.settingStore.getDlvRegistInfo.deliveryCode,
    deliveryServiceName: rootStore.settingStore.getDlvRegistInfo.deliveryServiceName,
    subDeliveryCode: rootStore.settingStore.getDlvRegistInfo.subDeliveryCode,
    parentDeliveryServiceName: rootStore.settingStore.getDlvRegistInfo.parentDeliveryServiceName,
    businessNumber: rootStore.settingStore.getDlvRegistInfo.businessNumber,
  });

  const api = Fn_activeAxios(rootStore);

  const res = await api.post("/gate/okgo/" + searchStore.getShopCd + "/delivery-mapping", data, {
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
  });
  try {
    if (res && res.status === 200) {
      const data = res.data;
      if (res.data.resultCode === "000") {
        if (data.resultMsg === "success") {
          if (rootStore.settingStore.getDlvRegistInfo.autoMappingYn == "Y") {
            rootStore.settingStore.setDlvConnectResult("complete");
            search_dlv_store_info(rootStore);
          } else {
            rootStore.settingStore.setDlvConnectResult("send");
          }
          rootStore.layerStore.setDlvConnectAdd(false);
          rootStore.layerStore.setLayerDlvConnectShopView(false);
          rootStore.layerStore.setDlvConnectResultView(true);
        }
      } else {
        if (data.resultCode === "DM0001") {
          rootStore.settingStore.setDlvConnectResult("warning");
        } else {
          if (data.resultCode === "DM0004") {
            rootStore.settingStore.setDlvConnectResult("confirm");
            rootStore.deliveryStore.setDlvConnectShopList(data.data);
            rootStore.layerStore.setLayerDlvConnectShopView(true);
          } else {
            rootStore.settingStore.setDlvConnectResult("fail");
            rootStore.layerStore.setDlvConnectResultView(true);
            fn_devliery_connect_add_reset(rootStore);
          }
          rootStore.layerStore.setDlvConnectAdd(false);
        }
      }
    }
  } catch (error) {
    console.log("delivery_connect_request", error);
    rootStore.settingStore.setDlvConnectResult("fail");
    rootStore.layerStore.setDlvConnectResultView(true);
    fn_devliery_connect_add_reset(rootStore);
  }
}

// 배달대행사 연동 해지
export async function delivery_disconnect_request(rootStore, obj) {
  const searchStore = rootStore.searchStore;

  let data = JSON.stringify({
    activate: false,
    shopCd: searchStore.getShopCd,
    agenCyCode: "",
    businessNumber: "",

    shopName: obj.shopName,
    autoMappingYn: obj.autoMappingYn,
    deliveryCode: obj.delivery_code,
    deliveryServiceName: obj.delivery_name,
    subDeliveryCode: obj.subDeliveryCode,
    parentDeliveryServiceName: obj.parent_delivery_name,
  });

  const api = Fn_activeAxios(rootStore);

  try {
    return await api.post("/gate/okgo/" + searchStore.getShopCd + "/delivery-mapping", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    });
  } catch (error) {
    console.log("delivery_disconnect_request", error);
    return null;
  }
}

//원산지 출력 설정 조회
export function origin_info_item(rootStore) {
  const searchStore = rootStore.searchStore;
  const api = Fn_activeAxios(rootStore);
  api
    .get("/gate/okgo/" + searchStore.getShopCd + "/origin-info", {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          let data = res.data.data;
          rootStore.settingStore.setOriginSettingInfo("originInfoYn", data.originInfoYn);
          rootStore.settingStore.setOriginSettingInfo("originInfo", data.originInfo != null ? data.originInfo : "");
          return true;
        }
      }
    })
    .catch(err => {});
}

//원산지 출력 설정 저장
export function origin_info_item_save(rootStore) {
  const searchStore = rootStore.searchStore;

  let data = JSON.stringify({
    shopCd: searchStore.getShopCd,
    originInfoYn: rootStore.settingStore.getOriginSettingInfo.originInfo == "" ? "N" : "Y",
    originInfo: rootStore.settingStore.getOriginSettingInfo.originInfo,
  });

  const api = Fn_activeAxios(rootStore);
  api
    .post("/gate/okgo/" + searchStore.getShopCd + "/origin-info", data, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        const data = res.data;
        if (res.data.resultCode === "000") {
          if (data.resultMsg == "success") {
          }
        }
      }
    })
    .catch(err => {});
}

//사용포스 목록 조회
export async function use_pos_list(rootStore) {
  const api = Fn_activeAxios(rootStore);
  let res = await api
    .get("/gate/okgo/" + rootStore.searchStore.getShopCd + "/use-poses", {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + rootStore.searchStore.getToken },
    })
    .then(res => {
      if (res && res.status === 200) {
        if (res.data.resultCode === "000") {
          rootStore.settingStore.setUsePosList(res.data.data.usePoses);
          return true;
        }
      }
    })
    .catch(err => {});
  return res;
}
